import { render } from "./AdministratorComponent.vue?vue&type=template&id=39d09504"
import script from "./AdministratorComponent.vue?vue&type=script&lang=js"
export * from "./AdministratorComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/administrators/AdministratorComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39d09504"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39d09504', __exports__)) {
    api.reload('39d09504', __exports__)
  }
  
  module.hot.accept("./AdministratorComponent.vue?vue&type=template&id=39d09504", () => {
    api.rerender('39d09504', render)
  })

}


export default __exports__